import { Type } from "@sinclair/typebox";
const object = { additionalProperties: false };
export const measurementPositionSchema = Type.Tuple([
    Type.Number({ minimum: -180, maximum: 180 }),
    Type.Number({ minimum: -85, maximum: 85 })
]);
export const measurementGeometrySchema = Type.Union([
    Type.Object({
        type: Type.Literal("LineString"),
        coordinates: Type.Array(measurementPositionSchema, { minItems: 2, maxItems: 1000 })
    }, object),
    Type.Object({
        type: Type.Literal("Polygon"),
        coordinates: Type.Array(Type.Array(measurementPositionSchema, { minItems: 4, maxItems: 1001 }), { minItems: 1, maxItems: 1 })
    }, object)
]);
const decimal = Type.String({ pattern: "^\\d{1,10}(?:\\.\\d{1,4})?$" });
export const mapMeasurementSchema = Type.Object({
    id: Type.String({ minLength: 1, maxLength: 120 }),
    provenance: Type.Optional(Type.Object({ kind: Type.Literal("ai_geometry"), proposalId: Type.String({ format: "uuid" }) }, object)),
    name: Type.String({ minLength: 1, maxLength: 200, pattern: "\\S" }),
    note: Type.Optional(Type.String({ maxLength: 2000 })),
    tool: Type.Union([Type.Literal("distance"), Type.Literal("area")]),
    source: Type.Literal("map"),
    status: Type.Literal("indicative"),
    value: decimal,
    unit: Type.Union([Type.Literal("m"), Type.Literal("m²")]),
    perimeterM: Type.Optional(decimal),
    geometry: measurementGeometrySchema
}, object);
export const mapMeasurementNotebookSchema = Type.Object({
    buildingId: Type.String({ format: "uuid" }),
    revision: Type.Integer({ minimum: 0 }),
    measurements: Type.Array(mapMeasurementSchema, { maxItems: 100 }),
    updatedAt: Type.Union([Type.String(), Type.Null()])
}, object);
export const saveMapMeasurementsSchema = Type.Object({
    expectedRevision: Type.Integer({ minimum: 0 }),
    measurements: Type.Array(mapMeasurementSchema, { maxItems: 100 })
}, object);
//# sourceMappingURL=map-measurements.js.map